var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('b-container',{attrs:{"fluid":""}},[_c('a',{attrs:{"href":"https://systemico.net","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("© "+_vm._s(_vm.fecha)+" Systemico® Technologies LLC")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }